var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mapbox-coordinates",style:(`--sidebar-width: ${_vm.appNavigationWidth}px`)},[_vm._v(" "+_vm._s(_vm.coordinates)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }